var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"pr-status-badge",style:(_vm.badgeConfig.badgeStyle)},[_vm._v(" "+_vm._s(_vm.badgeConfig.badgeLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }